import { NaturalNumber_Schema } from "@/utilities";
import { z } from "zod";

export const ThemeId_Schema = NaturalNumber_Schema;

export const Theme_Schema = z.object({
  name: z.string(),
  release: z.iso.datetime({ offset: true }).nullable(),
  symbol: z.string().nullable(), // absolute URL
});
